import { render, staticRenderFns } from "./Quotes.html?vue&type=template&id=633ee044&scoped=true&"
import script from "./Quotes.js?vue&type=script&lang=js&"
export * from "./Quotes.js?vue&type=script&lang=js&"
import style0 from "./Quotes.scss?vue&type=style&index=0&id=633ee044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ee044",
  null
  
)

export default component.exports